<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col 
              cols="12" 
              sm="8" 
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs"
                    v-on="on"
                    @click="regresar"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>
              Categorias Asociadas - {{ competencia.competencia }}
            </v-col>

            <v-col 
              cols="12" 
              sm="4"
            >
              <div class="d-flex align-center">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  label="Buscar Categoria"
                  class="mr-4"
                  v-model="searchTable"
                >
                </v-text-field>

                <v-btn 
                  color="primary" 
                  @click="abrirDialog"
                >
                  Asociar
                </v-btn>  
              </div>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          fixed-header
          height="calc(100vh - 220px)"
          class="elevation-2"
          :headers="headersTable"
          :items="categoriasCompetencia"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2"
                  @click="editar(item.categoria_id, item.competencia_id)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Actualizar</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2"
                  @click="registrarCupo(item.categoria_id, item.competencia_id)"
                >
                  mdi-text-box-plus
                </v-icon>
              </template>
              <span>Gestionar Cupos</span>
            </v-tooltip>

            <template v-if="item.estado_inscripcion">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="estadoInscripcion(item.categoria_id, item.competencia_id)"
                  >
                    mdi-timer-outline
                  </v-icon>
                </template>
                <span>Finalizar Inscripciones</span>
              </v-tooltip>
            </template>

            <template v-else>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                    @click="estadoInscripcion(item.categoria_id, item.competencia_id)"
                  >
                    mdi-timer-outline
                  </v-icon>
                </template>
                <span>Abrir Inscripciones</span>
              </v-tooltip>
            </template>
            
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                    @click="alertaEliminar(item.categoria_id, item.competencia_id)"
                  >
                    mdi-delete
                  </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip> -->
          </template>

          <template v-slot:top>
            <v-dialog 
              persistent 
              max-width="520px"
              v-model="dialogForm"
            >
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">
                    {{ formTitle }}
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="10">
                        <v-form ref="form" v-model="form">
                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Competencia"
                            v-model="competenciaSeleccionada"
                          >
                          </v-text-field>

                          <v-select
                            outlined
                            dense
                            :disabled="editedIndex !== -1"
                            label="Categoria*"
                            :items="categorias"
                            item-value="id"
                            item-text="categoria"
                            v-model="categoria"
                            :rules="categoriaReglas"
                          >
                          </v-select>
                
                          <v-select
                            outlined
                            dense
                            label="Modalidad*"
                            :items="modalidades"
                            item-value="id"
                            item-text="modalidad"
                            v-model="modalidad"
                            :rules="modalidadReglas"
                          >
                          </v-select>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Número de Participantes*"
                            min="0"
                            v-model="numeroParticipantes"
                            :rules="numeroParticipantesReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            readonly
                            type="number"
                            label="Número de Grupos"
                            :value="cantidadGrupos"
                            :rules="cantidadGruposReglas"
                          >
                          </v-text-field>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="cerrarDialog">
                    Cancelar
                  </v-btn>

                  <template v-if="editedIndex === -1">
                    <v-btn text exact color="primary" @click="asignar">
                      Asociar
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn text exact color="primary" @click="actualizar">
                      Actualizar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </v-card> 

      <!-- alerta eliminar -->
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="justify-center text-h5">
            ¿Desea eliminar la categoria?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
              text color="primary" 
              @click="closeDelete"
            >
              Cancelar 
            </v-btn>
            <v-btn
              text
              color="error"
              @click="eliminar"
            >
              OK
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog> 
    </template>
  </div>
</template>

<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    headersTable: [
      {
        text: "Categoria",
        value: "categoria",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Modalidad",
        value: "modalidad",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "# Participantes",
        value: "numero_participantes",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "# Grupos",
        value: "cantidad_grupos",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],

    form: true,
    loadingForm: false,

    dialogForm: false,
    dialogDelete: false,

    idCategoria: null,
    idCompetencia: null,
    
    competenciaSeleccionada: '',

    categoria: null,
    categoriaReglas: [
      (v) => !!v || "Seleccione una categoria"
    ],

    modalidad: null,
    modalidadReglas: [
      (v) => !!v || "Seleccione una modalidad"
    ],

    numeroParticipantes: null,
    numeroParticipantesReglas: [
      v => !!v || "Escriba un número de participantes",
      v => !v || v > 0 || "El número debe ser mayor a 0",
    ],
    
    cantidadGruposReglas: [
      (v) => v > 0 || "El número de participantes no coincide con la modalidad"
    ],

    editedIndex: -1,
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("detallesCompetencia", this.$route.params.id_competencia);

    this.$store.dispatch("gestionarCategoriasCompetencia", this.$route.params.id_competencia);

    this.$store.dispatch("gestionarCategorias");
    this.$store.dispatch("crearModalidades");

    setTimeout(() => {
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Asociar Categoria"
        : "Actualizar Categoria";
    },

    categoriasCompetencia() {
      return this.$store.getters.obtenerCategoriasCompetencia;
    },

    competencia() {
      return this.$store.getters.obtenerCompetencia;
    },

    categorias() {
      return this.$store.getters.obtenerCategorias;
    },

    modalidades() {
      return this.$store.getters.obtenerModalidades;
    },

    cantidadGrupos() {
      if (this.modalidad == 3) {
        if (this.numeroParticipantes % 3 == 0) {
          return this.numeroParticipantes / this.modalidad;
        }
        return 0;
      }
      else if (this.modalidad == 2) {
        if (this.numeroParticipantes % 2 == 0) {
          return this.numeroParticipantes / this.modalidad;
        }
        return 0;
      }

      return this.numeroParticipantes;
    },
  },

  watch: {
    dialog(val) {
      val || this.cerrarDialog();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    abrirDialog() {
      this.dialogForm = true;
      this.competenciaSeleccionada = this.competencia.competencia;
    },

    cerrarDialog() {
      this.$refs.form.reset();
      this.dialogForm = false;
      this.editedIndex = -1;
    },

    asignar() {
      if (this.$refs.form.validate()) {
        const categoriaCompetencia = {
          competencia_id: this.$route.params.id_competencia,
          categoria_id: this.categoria,
          modalidad_id: this.modalidad,
          numero_participantes: this.numeroParticipantes,
          cantidad_grupos: this.cantidadGrupos,
        };

        this.loadingForm = true;

        this.$store.dispatch("asignarCategoriaCompetencia", categoriaCompetencia)
        .then((response) => {
          if (response.status == "success") {
            this.cerrarDialog();
            this.loadingForm = false;

            const message     = response.message.split(",");
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true

            this.$store.dispatch("gestionarCategoriasCompetencia", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false
              this.skeletonLoader = false
            }, 2000)
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    editar(idCategoria, idCompetencia) {
      this.editedIndex = 1;

      this.competenciaSeleccionada = this.competencia.competencia;

      const categoriaCompetencia = {
        competencia_id: idCompetencia,
        categoria_id: idCategoria,
      };

      this.$store.dispatch("editarCategoriaCompetencia", categoriaCompetencia)
        .then((response) => {
          this.categoria = response.categoria_id;
          this.modalidad = response.modalidad_id;
          this.numeroParticipantes = response.numero_participantes;
        })
        .catch(() => {});

      this.dialogForm = true;
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        const categoriaCompetencia = {
          competencia_id: this.$route.params.id_competencia,
          categoria_id: this.categoria,
          modalidad_id: this.modalidad,
          numero_participantes: this.numeroParticipantes,
          cantidad_grupos: this.cantidadGrupos,
        };

        this.loadingForm = true;

        this.$store.dispatch("actualizarCategoriaCompetencia", categoriaCompetencia)
        .then((response) => {
          if (response.status == "success") {
            this.cerrarDialog();
            this.loadingForm = false;
            
            const message     = response.message.split(",");
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true

            this.$store.dispatch("gestionarCategoriasCompetencia", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false
              this.skeletonLoader = false
            }, 2000)
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    registrarCupo(idCategoria, idCompetencia) {
      this.$router.push({
        name: "cupo-gestionar",
        params: { id_categoria: idCategoria, id_competencia: idCompetencia },
      });
    },

    estadoInscripcion(idCategoria, idCompetencia) {
      const categoriaCompetencia = {
        categoria: idCategoria,
        competencia: idCompetencia
      }

      this.$store.dispatch("estadoInscripcion", categoriaCompetencia)
      .then((response) => {
        if (response.status == "success") {
          const message     = response.message.split(",");
          this.alertType    = "success--text";
          this.alertTitle   = message[0];
          this.alertMessage = message[1];
          this.alert        = true;

          this.skeletonLoader = true

          this.$store.dispatch("gestionarCategoriasCompetencia", this.$route.params.id_competencia);
          setTimeout(() => {
            this.alert = false
            this.skeletonLoader = false
          }, 2000)
        } 
        else {
          this.loadingForm  = false
          this.alertType    = "error--text";
          this.alertTitle   = "Error";

          for (const error in response.message) {
            this.alertMessage = response.message[error][0]
          }

          this.alert = true;

          setTimeout(() => {
            this.alert = false
          }, 3000)
        }
      })
      .catch(() => {});
    },

    alertaEliminar(categoria_id, competencia_id) {
      this.idCategoria = categoria_id;
      this.idCompetencia = competencia_id;
      this.dialogDelete = true;
    },

    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },

    eliminar() {
      this.dialogDelete = false;

      const categoriaCompetencia = {
        categoria_id: this.idCategoria,
        competencia_id: this.idCompetencia,
      };

      this.$store.dispatch("eliminarCategoriaCompetencia", categoriaCompetencia)
      .then((response) => {
        if (response.status == "success") {
          const message     = response.message.split(",");
          this.alertType    = "success--text";
          this.alertTitle   = message[0];
          this.alertMessage = message[1];
          this.alert        = true;

          this.skeletonLoader = true

          this.$store.dispatch("gestionarCategoriasCompetencia", this.$route.params.id_competencia);
          setTimeout(() => {
            this.alert = false
            this.skeletonLoader = false
          }, 2000)
        } 
        else {
          this.loadingForm  = false
          this.alertType    = "error--text";
          this.alertTitle   = "Error";

          for (const error in response.message) {
            this.alertMessage = response.message[error][0]
          }

          this.alert = true;

          setTimeout(() => {
            this.alert = false
          }, 3000)
        }
      })
      .catch(() => {});
    },

    regresar() {
      this.$router.back()
    },
  },
};
</script>
